import { Constants } from '../constants'

export function setCurrentTenantId(tenantId: string): void {
  localStorage.setItem(Constants.TenantId, tenantId)
}

export function getCurrentTenantId(): string | undefined {
  const currentTenantId = localStorage.getItem(Constants.TenantId) || undefined
  return currentTenantId
}

export function useCurrentTenantId(): string | undefined {
  return getCurrentTenantId()
}

export function setCurrentTenantName(tenantName: string): void {
  localStorage.setItem(Constants.TenantName, tenantName)
}

export function getCurrentTenantName(): string | undefined {
  const currentTenantName = localStorage.getItem(Constants.TenantName) || undefined
  return currentTenantName
}

export function useCurrentTenantName(): string | undefined {
  return getCurrentTenantName()
}
